//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import DispatchRequestBatchModel from '@/models/Warehouse/WhDispatchRequestBatch'
import TranslatorService from '@/services/translator'

//
import fields from './fields'

//
export default {
    name: 'dispatch-requests-batch-update',
    components: {
        'model-form': ModelForm,
    },
    computed: {

        /**
         * Snackbar module states
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        formProps() {
            return {
                editable:
                    //this.formData.can_edit &&
                    this.$can('EDIT_DISPATCH_REQUEST_BATCH'),
                fields: fields(this.formData),
                loading: this.busy,
                switchEdit:
                    this.$can('EDIT_DISPATCH_REQUEST_BATCH') &&
                    this.formData.can_edit,
            }
        },

        /**
         *
         */
        title() {
            return `Lote de despacho #${this.$route.params.id}`
        },
    },
    data() {
        return {
            busy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', ['setTitleTopBar']),

        //
        ...mapActions('SnackbarModalModule', [
            'resetSnackbarState',
            'setErrorSnackbar',
            'setSuccessSnackbar',
            'setWarningSnackbar',
        ]),

        /**
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(
                    DispatchRequestBatchModel,
                    error.response.data
                )
            )
        },

        /**
         *
         */
        fetch() {
            DispatchRequestBatchModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'dispatch-request-batch' })
        },

        /**
         *
         */
        reset() {
            this.toggleBusy().then(this.fetch)
        },

        /**
         *
         */
        setFormData(model) {
            this.busy = false
            this.formData = model.reset()
        },

        /**
         *
         */
        submit() {
            return this.$refs.form
                .setWait(true)
                .then(this.toUpdate)
                .finally(this.$refs.form.setWait)
                .then(this.successUpdate)
                .catch(this.error)
        },

        /**
         *
         */
        submitDispatch() {
            //
            if (!this.formData.can_dispatch) {
                //
                return this.setErrorSnackbar(
                    'Faltan solicitudes de despacho por facturar.'
                )
            }

            //
            this.setWarningSnackbar({
                title: '¿Deseas despachar el lote de despacho?',
                message: 'Una vez despachado no se puede editar.',
                confirm: 'despachar',
            })
        },

        /**
         *
         */
        successUpdate() {
            this.setSuccessSnackbar('Lote de despacho actualizado.')
        },

        /**
         *
         */
        successDispatch() {
            this.setSuccessSnackbar('Lote despachado exitosamente.')
        },

        /**
         *
         */
        async toggleBusy() {
            this.busy = !this.busy
        },

        /**
         *
         */
        toDispatch() {
            return this.formData
                .dispatched()
                .sync()
                .finally(this.$refs.form.setWait)
                .then(this.successDispatch)
                .then(this.redirect)
                .catch(this.error)
        },

        /**
         *
         */
        toUpdate(model) {
            return model.toUpdate().save()
        },
    },
    watch: {
        /**
         *
         */
        async responseConfirm(value) {
            switch (value) {
                case 'despachar':
                    this.toDispatch()
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_DISPATCH_REQUEST_BATCH'))
                ctx.$router.push('/')
        })
    },
    beforeMount() {
        this.setTitle(this.title)
    },
    mounted() {
        this.reset()
    },
}
